<template>
	<a class='person'
		v-if='person.photo_big'
		:href='`/profile/${person.id}/`'
	>
		<header class='person-picture' :style='`background-image: url(${person.photo_big});`'></header>
		<span class='person-image-title'>{{person.name}}</span>
		<div class='agent-icon agent-icon-md' v-if='person.type=="agent"'>
			<icon icon-name='agent'/>
		</div>
	</a>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
export default {
	name:       'Person',
	components: {
		icon
	},
	props: {
		person: {
			type: Object
		}
	}
};
</script>
